import * as THREE from "three"
import React, { Suspense, useRef } from 'react'
import { RoundedBox } from "@react-three/drei"

const RoundedGlass = React.forwardRef(({
  args = [2, 2, 2],
  radius = 0.3,
  smoothness = 8, 
  transmission = 1,
  roughness = 0,
  thickness = 3,
  ...props
  }, ref) => {
  return (
    <RoundedBox ref={ref} args={args} radius={radius} smoothness={smoothness} {...props}>
      <meshPhysicalMaterial transmission={transmission} roughness={roughness} thickness={thickness} envMapIntensity={4} />
    </RoundedBox>
  )
})

export default RoundedGlass